<template>
  <div
    v-if="isInside && !$i18n.g1"
    class="guidetooltip gw_hvr_content csst csst_after clr-grey mdi mdi-help-circle"
    style="
      --csst-min-after-inset: auto auto -0% 50%;
      --csst-min-after-height: 100%;
      --csst-min-after-width: 200%;
    "
    @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: placement })"
  >
    <div
      class="csst_content csst_content_hoverable clr-white text-small capitalize"
      style="position: fixed"
      v-html="guides[guide]"
    ></div>
  </div>
  <GwMenu
    v-else-if="!$i18n.g1"
    class="gw_hvr_content"
    trigger="hover"
    :placement="placement"
    :flOptions="{ offset: 0 }"
  >
    <!-- :isEager="true" -->
    <template #opener>
      <div class="clr-grey mdi mdi-help-circle guidetooltip"></div>
    </template>
    <div
      class="csst_content csst_content_visible csst_content_hoverable clr-white text-small capitalize text-nowrap"
      style="padding: var(--padding); position: relative"
      v-html="guides[guide]"
    ></div>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import links_mix from '@/mixins/links_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'GuideTooltip',
  components: {
    GwMenu,
  },
  mixins: [links_mix, float_mix],
  props: {
    guide: { default: 'range_tab' },
    placement: { default: 'bottom' },
    isInside: { type: Boolean, default: true },
  },
  computed: {
    guides() {
      return {
        range_tab: this.$t('guides.see_guide', {
          text: this.$t('guides.range'),
          url: this.links_url_links.ranges_tab.url,
        }),
        breakdown_tab: this.$t('guides.see_guide', {
          text: this.$t('guides.breakdown'),
          url: this.links_url_links.breakdown_tab.url,
        }),
        eq_chart: this.$t('guides.see_guide', {
          text: this.$t('guides.eq_chart'),
          url: this.links_url_links.eq_chart.url,
        }),
        ra_compare_combos: this.$t('guides.see_guide', {
          text: this.$t('guides.combos'),
          url: this.links_url_links.ra_compare_combos.url,
        }),
        ra_compare_ev: this.$t('guides.see_guide', {
          text: this.$t('guides.ev'),
          url: this.links_url_links.ra_compare_ev.url,
        }),
        ra_compare_eq: this.$t('guides.see_guide', {
          text: this.$t('guides.equity'),
          url: this.links_url_links.ra_compare_eq.url,
        }),
        ra_compare_eqr: this.$t('guides.see_guide', {
          text: this.$t('guides.eqr'),
          url: this.links_url_links.ra_compare_eqr.url,
        }),
        bubble_factor: this.$t('guides.see_guide', {
          text: this.$t('guides.bubble_factor'),
          url: this.links_url_links.bubble_factor.url,
        }),
        icm_pko: this.$t('guides.see_guide', {
          text: this.$t('guides.icm_pko'),
          url: this.links_url_links.icm_pko.url,
        }),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.guidetooltip {
  font-size: 0.8rem;
  border-radius: 50%;
}
</style>
